module.exports = __webpack_public_path__ + "img/icon-close_47cf0.png";